import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { useDrfqTakerOrderbook } from '@paradigm/features/src/unified-rfqs/ui/drfq/drfq-taker-orderbook-context';
import { getUserTicker } from '@paradigm/store/auth';
import { useUMPlatformKillDisabled } from '@paradigm/features/src/platform-state/contexts/providers';
import KillOrderButton from '../KillOrderButton';
import {
  CenterArea,
  PriceCell,
  QuantityCell,
  Row,
  SideArea,
  Space,
  SubTitle,
  Title,
} from './ScreenPriceAndHiddenOrderContainer';

const KillCell = styled.div`
  grid-area: kill;
`;

const HiddenOrders: React.FC<{ 'data-testid'?: string }> = (props) => {
  const isPlatformKillDisabled = useUMPlatformKillDisabled();
  const userDesk = useSelector(getUserTicker)!;
  const view = useDrfqTakerOrderbook();
  const { bids, asks } =
    view.state === 'OPEN_AUCTION' ? view : { bids: [], asks: [] };

  const myBid_ = bids.find(
    (bid) => bid.desk === userDesk || bid.type === 'HIDDEN',
  );
  const myAsk_ = asks.find(
    (ask) => ask.desk === userDesk || ask.type === 'HIDDEN',
  );

  const myBid = myBid_ || null;
  const myAsk = myAsk_ || null;

  if (myBid == null && myAsk == null) return null;

  return (
    <Row data-testid={props['data-testid']}>
      <SideArea>
        <Title>My Bid</Title>
        <SubTitle>Hidden</SubTitle>
      </SideArea>
      <CenterArea>
        <QuantityCell>
          {myBid ? myBid.quantity : '-'}
          {myBid && (
            <KillCell>
              <KillOrderButton
                orderId={myBid.id}
                disabled={isPlatformKillDisabled}
              />
            </KillCell>
          )}
        </QuantityCell>
        <Space />
        <PriceCell>{myBid ? myBid.price : '-'}</PriceCell>
        <Space />
        <PriceCell>{myAsk ? myAsk.price : '-'}</PriceCell>
        <QuantityCell>
          {myAsk ? myAsk.quantity : '-'}
          {myAsk && (
            <KillCell>
              <KillOrderButton
                orderId={myAsk.id}
                disabled={isPlatformKillDisabled}
              />
            </KillCell>
          )}
        </QuantityCell>
      </CenterArea>
      <SideArea>
        <Title>My Ask</Title>
        <SubTitle>Hidden</SubTitle>
      </SideArea>
    </Row>
  );
};

export default HiddenOrders;
